import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
// material
import { styled, useTheme } from "@mui/material/styles";
// hooks
import useCollapseDrawer from "../../hooks/useCollapseDrawer";
//
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import socket from "src/socket";

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP,
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const theme = useTheme();
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);
  const [addNotification, setAddNotification] = useState(false);

  useEffect(() => {
    socket.on("connect", () => {
      console.log("Successfully connected to the server");
    });

    socket.on("disconnect", (reason) => {
      console.log(`Disconnected: ${reason}`);
      if (reason === "io server disconnect") {
        // If server explicitly disconnects, try reconnecting manually
        socket.connect();
      }
    });

    socket.on("reconnect_attempt", (attempt) => {
      console.log(`Reconnecting... Attempt #${attempt}`);
    });

    socket.on("reconnect", (attempt) => {
      console.log(`Reconnected successfully after ${attempt} attempt(s)`);
    });

    socket.on("reconnect_failed", () => {
      console.error("Reconnection failed. Manual retry may be needed.");
      setTimeout(() => socket.connect(), 5000); // Retry after 5 seconds
    });

    socket.on("connect_error", (error) => {
      console.error("Connection error:", error.message);
    });

    socket.connect();

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <RootStyle>
      <DashboardNavbar
        onOpenSidebar={() => setOpen(true)}
        setAddNotification={setAddNotification}
      />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />
      <MainStyle
        sx={{
          paddingTop: "100px",
          paddingLeft: "0px",
          background: "#FFFAF3",
          transition: theme.transitions.create("margin", {
            duration: theme.transitions.duration.complex,
          }),
          ...(collapseClick && {
            ml: "22px",
          }),
        }}
      >
        <Outlet addNotification={addNotification} />
      </MainStyle>
    </RootStyle>
  );
}
